<!-- This component is Stripe integration for Google Pay and Apple Pay-->
<template>
  <div v-if="showStripePayment">
    <h5 class="text-divider"></h5>
    <div id="payment-request-button"></div>
    <div
        v-if="
        customGooglePayImage &&
        enableGooglePay &&
        canGooglePay
      "
        class="gpay-gift-custom-button"
        @click="clickCustomButton('google')"
    >
      <img v-if="isGift" src="../../../../assets/gpay.svg"/>
      <img v-else src="../../../../assets/Google_Pay_Logo.svg"/>
    </div>

    <div
      v-if="
        customApplePayImage &&
        enableApplePay &&
        canApplePay
      "
      class="apay-gift-custom-button"
      @click="clickCustomButton('apple')"
    >
      <!-- currently empty, we use default Stripe Apple Pay Image -->
    </div>

    <div style="color: red">{{ error }}</div>

    <h5 class="text-divider"><span>Or Pay with Card</span></h5>

  </div>
</template>

<script>
import {StripePay} from "@/api/payment/stripePay";
import {mapGetters} from "vuex";
import {AppConfig} from "../../../../../AppConfig";
import { getCurrency, getStoreLocale } from '../../../../api/helpers/storeHelper';

export default {
  data() {
    return {
      stripePay: new StripePay(),
      error: "",
      refernceId: 0,
      stripe: null,
      paymentRequest: null,
      trackingOrder: null,
      tokenId: null,
      canGooglePay: false,
      canApplePay: false,
      showStripePayment: false,
    };
  },
  props: {
    customGooglePayImage: {
      type: Boolean,
      default: false,
    },
    customApplePayImage: {
      type: Boolean,
      default: false,
    },
    enableGooglePay: {
      type: Boolean,
      default: true,
    },
    enableApplePay: {
      type: Boolean,
      default: true,
    },
    bus: {
      type: Object,
      default: () => {},
    },
    storeId: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters(["getTotalPrice", "selectedCompany", "isGift"]),
    giftTotalPrice: {
      get() {
        return this.$store.getters["newGiftShoppingCart/giftTotalPrice"];
      },
    },
  },
  created() {
    const that = this;
    //this is mainly for gift
    this.bus.$on("giftTotalPriceUpdated", (args) => {
      that.paymentRequest.update({
        total: {
          label: "Item is removed",
          amount: parseInt(args.amount * 100, 10),
        },
      });
    });
  },
  async mounted() {
    const that = this;
    const stripeEnabled = await this.isStripeEnabled();
    if (!stripeEnabled) {
      this.showStripePayment = false;
      return;
    }

    // if (this.enableApplePay || this.enableGooglePay) {
    //   this.showStripePayment = true;
    // }
    // eslint-disable-next-line no-undef
    const stripeToken = this.selectedCompany && this.selectedCompany.PaymentConfigEnvironment === 'Sandbox' ? AppConfig.stripeTestToken : AppConfig.stripeToken;
    const currency = getCurrency(this.selectedCompany.CurrencyLocaleName);
    const country = getStoreLocale(this.selectedCompany.CurrencyLocaleName);
    this.stripe = Stripe(stripeToken);
    const totalAmount = this.isGift ? this.giftTotalPrice : this.getTotalPrice;
    this.paymentRequest = this.stripe.paymentRequest({
      country,
      currency,
      total: {
        label: this.selectedCompany.Name,
        amount: parseInt(totalAmount * 100, 10), // total in cent
      },
      requestPayerName: false,
      requestPayerEmail: false,
    });

    const elements = this.stripe.elements();
    const prButton = elements.create("paymentRequestButton", {
      paymentRequest: that.paymentRequest,
    });

    // Check the availability of the Payment Request API first.
    this.paymentRequest.canMakePayment().then(function (result) {
      if (!result) {
        that.showStripePayment = false;
        return;
      }
      that.showStripePayment = !!(result.applePay || result.googlePay);

      that.canGooglePay = result.googlePay;
      that.canApplePay = result.applePay;

      //currently no broswer can handle both apple and google pay at the same time
      //but we leave the logic in here just in case button will not be mounted twice
      let isPrButtonMounted = false;
      if (
          that.enableGooglePay &&
          !that.customGooglePayImage &&
          that.canGooglePay
      ) {
        prButton.mount("#payment-request-button");
        isPrButtonMounted = true;
      }

      if (
          that.enableApplePay &&
          !that.customApplePayImage &&
          that.canApplePay &&
          !isPrButtonMounted
      ) {
        prButton.mount("#payment-request-button");
      }

    });
    prButton.on("click", (event) => {
      event.preventDefault();
      if (this.canGooglePay) this.$emit("stripe-click", 7);
      if (this.canApplePay) this.$emit("stripe-click", 6);
    });

    this.beginPayment();
  },
  methods: {
    paymentMethod(ev) {
      const stripePay = new StripePay({});
      const that = this;
      this.$emit("proccessing", true);
      that.trackingOrder.TrackingOrder.PaymentTransactions[0].RenfrenceNumber =
        that.tokenId;

      stripePay.createOrder(that.trackingOrder).then((customerInfo) => {
        if (customerInfo.data.Success) {
          stripePay
            .createPayment(that.trackingOrder.TrackingOrder)
            .then((stripeDate) => {
              if (stripeDate.data.Success) {
                // Confirm the PaymentIntent without handling potential next actions (yet).
                that.stripe
                  .confirmCardPayment(
                    stripeDate.data.ClientSecret,
                    { payment_method: ev.paymentMethod.id },
                    { handleActions: false }
                  )
                  .then(function (confirmResult) {
                    if (confirmResult.error) {
                      // Report to the browser that the payment failed, prompting it to
                      // re-show the payment interface, or show an error message and close
                      // the payment interface.
                      that.$emit("error", confirmResult.error.message);
                      that.$emit("proccessing", false);
                      ev.complete("fail");
                    } else {
                      // Report to the browser that the confirmation was successful, prompting
                      // it to close the browser payment method collection interface.
                      ev.complete("success");
                      // The payment has succeeded.
                      that.finalizeAsync(that.trackingOrder);
                      // Let Stripe.js handle the rest of the payment flow.
                      if (
                        confirmResult.paymentIntent &&
                        confirmResult.paymentIntent.status === "requires_action"
                      ) {
                        that.stripe
                          .confirmCardPayment(stripeDate.data.ClientSecret)
                          .then(function (result) {
                            if (result.error) {
                              that.$emit("proccessing", false);
                              that.$emit("error", result.error.message);
                              // The payment failed -- ask your customer for a new payment method.
                            } else {
                              // Report to the browser that the confirmation was successful, prompting
                              // it to close the browser payment method collection interface.
                              ev.complete("success");
                              // The payment has succeeded.
                              that.$emit(".302", that.trackingOrder);
                            }
                          });
                      }
                    }
                  });
              } else {
                that.$emit(
                  "error",
                  stripeDate.errMessage && stripeDate.errMessage.Message
                    ? stripeDate.errMessage.Message
                    : "Could not create a payment please try again"
                );
                that.$emit("proccessing", false);
                ev.complete("fail");
              }
            });
        } else {
          console.log(customerInfo.data);
          that.$emit(
            "error",
            customerInfo.errMessage && customerInfo.errMessage.Message
              ? customerInfo.errMessage.Message
              : "Could not create an order please try again"
          );
          that.$emit("proccessing", false);
          ev.complete("fail");
        }
      });
    },
    setTrackingOrder(trackingOrder) {
      this.trackingOrder = trackingOrder;
    },
    async finalizeAsync(trackingOrder) {
      this.$emit("finalize", trackingOrder);
    },
    beginPayment() {
      const that = this;
      that.$nextTick(() => {
        that.paymentRequest.on("token", function (event) {
          that.$emit("proccessing", true);
          that.tokenId = event.token ? event.token.id : null;
          that.trackingOrder.TrackingOrder.PaymentTransactions[0].RenfrenceNumber =
            that.tokenId;
          //that.trackingOrder.Card = null;
          // this approach is to use token to achieve the payment in the server side
          // currently disabled
          // if(that.tokenId == null)
          //     event.complete("fail");
          // else
          // {
          //     event.complete("success");
          //     that.$emit("stripePayTokenGenerated", that.trackingOrder);
          // }
        });
        that.paymentRequest.on("cancel", function () {
          // handle cancel event
          that.$emit("proccessing", false);
          that.$emit("cancel");
        });
        that.paymentRequest.on("paymentmethod", that.paymentMethod);
      });
    },
    showPayment() {
      this.paymentRequest.show();
    },
    clickCustomButton(paymentType) {
      if (paymentType === "google" && this.canGooglePay)
        this.$emit("stripe-click", 7);
      if (paymentType === "apple" && this.canApplePay)
        this.$emit("stripe-click", 6);
    },

    async isStripeEnabled() {
      if(!this.storeId) return false
      return await this.stripePay.stripeEnabledForStore(
          this.storeId
      );
    },
  },
};
</script>

<style>
.enabled {
  opacity: 1;
}
</style>
